import { createSelector } from 'reselect';

export default (...inputSelectors) => {
  const selectors = {};
  return (state, sliceId, ...rest) => {
    let selector = selectors[sliceId];
    if (!selector) {
      selector = createSelector(...inputSelectors);
      selectors[sliceId] = selector;
    }
    return selector(state, sliceId, ...rest);
  };
};
